import { Route, Routes } from "react-router-dom";
// page routes
import Home from "./pages/HomePage";
import Page404 from "./components/page404/page404";
import BetAmountPage from "./pages/BetAmountPage";
import SelectCardsPage from "./pages/SelectCardsPage";
import ConfirmCardPage from "./pages/ConfirmCardPage";
import BetHistory from "./pages/BetHistory";
import BingoGame from "./pages/BingoGame";
import ProtectedRoutes from "./pages/protectedRoutes/ProtectedRoutes";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import HowToPlay from "./pages/HowToPlay";
import ReferralIncome from "./pages/ReferralIncome";
import WalletPage from "./pages/WalletPage";
import ProfilePage from "./pages/ProfilePage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpdateProfile from "./pages/UpdateProfile";
import Invoice from "./pages/Invoicer";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import UpdateUser from "./pages/AdminDashboard/UpdateUser";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Home />} />
          <Route path="/betamountpage" element={<BetAmountPage />} />
          <Route path="/select-cards" element={<SelectCardsPage />} />
          <Route path="/confirm/:id" element={<ConfirmCardPage />} />
          <Route path="/play" element={<BingoGame />} />
          <Route path="/history" element={<BetHistory />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/HowToPlay" element={<HowToPlay />} />
          <Route path="/referralIncome" element={<ReferralIncome />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile-update" element={<UpdateProfile />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/admin-page" element={<AdminDashboard />} />
          <Route path="/users/:id" element={<UpdateUser />} />
        </Route>
        <Route path="*" element={<Page404 />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </div>
  );
}

export default App;

